import VFileInput from 'vuetify/lib/components/VFileInput/VFileInput';

let FileEditor = VFileInput.extend({
  name: 'file-editor',
  props: {
    prependIcon: false,
    appendIcon: {
      default: '$file'
    }
  },

  methods: {
    genIconSlot () {
      const slot = [];
      const icon = this.genIcon('append', () => {
        this.$refs.input.click();
      });
      slot.push(icon)
      return this.genSlot('append', 'inner', slot);

    }
  }
})

export default {
  install: function (Vue) {
    Vue.component('file-editor', FileEditor)
  }
}